<template>
    <CardView title="Stakeholder Requirements" ttyId="8" :filterControls="filterControls"></CardView>
</template>

<script>
    import CardView from '@/components/CardView.vue'
    export default {
        name: 'StakeholderCards',
        components: {
            CardView
        },
        data() {
            return {
                filterControls: [{ matId: 876 }, { matId: 877 }]
            }
        },
    }
</script>
<style scoped>
</style>
